import { KeysResponse } from "../../../models/response/keys.response";

export class OrganizationKeysResponse extends KeysResponse {
  constructor(response: any) {
    super(response);
  }
}
